import React, { useEffect, useRef } from "react";

const FooterNetwork = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;

    if (!canvas) return undefined;

    const context = canvas.getContext("2d");

    if (!context) return undefined;

    let width = 0;
    let height = 0;
    let particles = [];

    const mouse = {
      x: null,
      y: null,
      radius: 120,
    };

    const createParticles = () => {
      const area = width * height;

      /*
       * Më shumë pika në desktop,
       * më pak në mobile për performancë.
       */
     const calculatedAmount = Math.floor(area / 4500);

const amount = Math.min(
    Math.max(calculatedAmount, 140),
    320
);

      particles = Array.from({ length: amount }, (_, index) => ({
        x: Math.random() * width,
        y: Math.random() * height,

        radius: Math.random() * 0.7 + 1.1,

        velocityX: (Math.random() - 0.5) * 0.22,
        velocityY: (Math.random() - 0.5) * 0.22,

        pulse: Math.random() * Math.PI * 2,
        pulseSpeed: Math.random() * 0.018 + 0.009,

        highlighted: index % 15 === 0,
      }));
    };

 const resizeCanvas = () => {
  const parent = canvas.parentElement;

  if (!parent) return;

  const rectangle = parent.getBoundingClientRect();
  const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);

  width = Math.max(1, Math.round(rectangle.width));
  height = Math.max(1, Math.round(rectangle.height));

  canvas.width = Math.round(width * pixelRatio);
  canvas.height = Math.round(height * pixelRatio);

  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;

  context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = "high";

  createParticles();
};

    const updateParticle = (particle) => {
      particle.x += particle.velocityX;
      particle.y += particle.velocityY;
      particle.pulse += particle.pulseSpeed;

      if (particle.x <= 0 || particle.x >= width) {
        particle.velocityX *= -1;
      }

      if (particle.y <= 0 || particle.y >= height) {
        particle.velocityY *= -1;
      }

      particle.x = Math.max(0, Math.min(width, particle.x));
      particle.y = Math.max(0, Math.min(height, particle.y));

      if (mouse.x !== null && mouse.y !== null) {
        const differenceX = particle.x - mouse.x;
        const differenceY = particle.y - mouse.y;
        const distance = Math.sqrt(
          differenceX * differenceX + differenceY * differenceY
        );

        if (distance < mouse.radius && distance > 0) {
          const force = (mouse.radius - distance) / mouse.radius;

          particle.x += (differenceX / distance) * force * 0.4;
          particle.y += (differenceY / distance) * force * 0.4;
        }
      }
    };

    const drawParticle = (particle) => {
      const pulseValue = (Math.sin(particle.pulse) + 1) / 2;

      const radius =
        particle.radius +
      pulseValue * (particle.highlighted ? 0.65 : 0.25);

      const opacity =
        particle.highlighted
          ? 0.62 + pulseValue * 0.38
          : 0.38 + pulseValue * 0.42;

      context.beginPath();
      context.arc(particle.x, particle.y, radius, 0, Math.PI * 2);

      context.fillStyle = particle.highlighted
        ? `rgba(34, 199, 242, ${opacity})`
        : `rgba(23, 105, 237, ${opacity})`;

      context.fill();

      if (particle.highlighted) {
        context.beginPath();
        context.arc(
          particle.x,
          particle.y,
          radius + 5 + pulseValue * 4,
          0,
          Math.PI * 2
        );

        context.strokeStyle = `rgba(34, 199, 242, ${
          0.1 + pulseValue * 0.16
        })`;

        context.lineWidth = 1;
        context.stroke();
      }
    };

    const drawConnections = () => {
      const maximumDistance = width < 760 ? 90 : 125;

      for (let firstIndex = 0; firstIndex < particles.length; firstIndex += 1) {
        for (
          let secondIndex = firstIndex + 1;
          secondIndex < particles.length;
          secondIndex += 1
        ) {
          const firstParticle = particles[firstIndex];
          const secondParticle = particles[secondIndex];

          const differenceX = firstParticle.x - secondParticle.x;
          const differenceY = firstParticle.y - secondParticle.y;

          const distance = Math.sqrt(
            differenceX * differenceX + differenceY * differenceY
          );

          if (distance < maximumDistance) {
            const opacity =
              (1 - distance / maximumDistance) * 0.22;

            context.beginPath();
            context.moveTo(firstParticle.x, firstParticle.y);
            context.lineTo(secondParticle.x, secondParticle.y);

            context.strokeStyle = `rgba(74, 144, 240, ${opacity})`;
            context.lineWidth = 0.7;
            context.stroke();
          }
        }
      }
    };

    const animate = () => {
       context.save();

        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);

        context.restore();

      particles.forEach(updateParticle);

      drawConnections();

      particles.forEach(drawParticle);

      animationRef.current = window.requestAnimationFrame(animate);
    };

    const handleMouseMove = (event) => {
      const rectangle = canvas.getBoundingClientRect();

      mouse.x = event.clientX - rectangle.left;
      mouse.y = event.clientY - rectangle.top;
    };

    const handleMouseLeave = () => {
      mouse.x = null;
      mouse.y = null;
    };

    resizeCanvas();
    animate();

    const resizeObserver = new ResizeObserver(() => {
        resizeCanvas();
        });

        resizeObserver.observe(canvas.parentElement);

    canvas.addEventListener("mousemove", handleMouseMove);
    canvas.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      resizeObserver.disconnect();

      canvas.removeEventListener("mousemove", handleMouseMove);
      canvas.removeEventListener("mouseleave", handleMouseLeave);

      if (animationRef.current) {
        window.cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="footer-network" aria-hidden="true">
      <canvas ref={canvasRef} className="footer-network-canvas" />
    </div>
  );
};

export default FooterNetwork;